import {ImageOpContextBase} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-base"
import {ImageProcessingNodes} from "@cm/image-processing-nodes"
import {Descriptor} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {ImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc"
import {createImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {ColorLike} from "@cm/math"
import {TexturesApiService} from "@app/textures/service/textures-api.service"

export class ImageOpContextImgProc extends ImageOpContextBase {
    readonly type = "imgproc"

    constructor(texturesApi: TexturesApiService) {
        super(texturesApi)
    }

    createEmptyImage(descriptor: Descriptor, fillColor: ColorLike = {r: 0, g: 0, b: 0, a: 1}): ImageOpImgProc {
        const getColor = (numChannels: number): number | ImageProcessingNodes.RGBColor | ImageProcessingNodes.RGBAColor => {
            switch (numChannels) {
                case 4:
                    return [fillColor.r, fillColor.g, fillColor.b, fillColor.a ?? 1]
                case 3:
                    return [fillColor.r, fillColor.g, fillColor.b]
                case 1:
                    return fillColor.r
                default:
                    throw new Error(`Unsupported channel count: ${numChannels}`)
            }
        }
        const color = getColor(descriptor.channels)
        return createImageOpImgProc(
            descriptor,
            ImageProcessingNodes.createImage(
                descriptor.width,
                descriptor.height,
                "float32",
                "linear", // TODO which color space?
                color,
            ),
        )
    }
}
